import React, {useEffect, useRef, useState} from "react";
import {TableVirtuoso} from "react-virtuoso";
import {SearchAndFilerFull} from "./searchAndFilerFull";
import {NotYet} from "./notYet";
import {FindLoad} from "utils";
import {Skeleton} from "@mui/material";
import {TableLoader} from "../loaders";

export const FullTableByScroll = ({
                                      classNameWrapper,
                                      head,
                                      body,
                                      list,
                                      loadingType,
                                      handleClick,
                                      onDoubleClick,
                                      generateTable,
                                      containerStyles = {},
                                      getCellForStyle = () => ({}),
                                      getRowForStyle = () => ({}),
                                      emptyState,
                                      tableFiltersBox
                                  }) => {
    const [listInfo, setListInfo] = useState(list);
    const [searched, setSearched] = useState({name: "", text: ""});
    const loader = FindLoad(loadingType ? loadingType : "");
    const headerRefs = useRef([]);
    const clickTimeout = useRef(null);
    const virtuosoRef = useRef(null);

    useEffect(() => {
        if (list && !searched?.value) {
            setListInfo(list);
        }
    }, [list]);

    // Trigger re-measure when list updates
    useEffect(() => {
        virtuosoRef.current?.recomputeItemHeights?.();
    }, [listInfo]);

    const renderItems = (item, cell, index) => {
        if (!cell) return null;

        if (cell?.button) {
            return cell?.button((name) => handleClick?.(item, name), item);
        }

        return cell?.rowText(item, index);
    };

    const handleCellClick = (e, cell, item) => {
        e.preventDefault();

        if (clickTimeout.current) {
            clearTimeout(clickTimeout.current);
            clickTimeout.current = null;
            if (item?.notClickable !== true && onDoubleClick) {
                onDoubleClick(item);
            }
        } else {
            clickTimeout.current = setTimeout(() => {
                clickTimeout.current = null;
                if (item?.notClickable !== true && handleClick) {
                    handleClick(item);
                }
            }, 250);
        }
    };

    const classesWrapper = ["full-table-styles"];
    if (classNameWrapper) classesWrapper.push(classNameWrapper);

    return (
        <div>
            {
                tableFiltersBox && tableFiltersBox(listInfo)
            }
            <div className={classesWrapper.join(" ")}>
                <div className="single-table-container" style={containerStyles}>
                    <TableVirtuoso
                        ref={virtuosoRef}
                        className={
                            loader?.length || !listInfo?.length ? "virtuoso-wrapper-scroll-only-horizontal" : "virtuoso-wrapper"
                        }
                        data={listInfo && listInfo.length > 0 ? listInfo : [{}]}
                        itemKey={(index, item) => item?.id ?? `empty-${index}`}
                        fixedHeaderContent={() => (
                            <div className="single-table-head">
                                {head?.map((i, j) => {
                                    const {ComponentView} = i;

                                    return (
                                        <div
                                            className="single-table-header-row"
                                            key={j}
                                            ref={(el) => (headerRefs.current[j] = el)}
                                            style={{
                                                width: i.width || "",
                                                minWidth: i.minWidth || "",
                                            }}
                                        >
                                            {i?.renderView ? (
                                                <div>{i.renderView}</div>
                                            ) : ComponentView ? (
                                                <ComponentView
                                                    setListInfo={setListInfo}
                                                    list={list}
                                                    item={i}
                                                    searched={searched}
                                                    setSearched={setSearched}
                                                    generateTable={generateTable}
                                                />
                                            ) : (
                                                <SearchAndFilerFull
                                                    setListInfo={setListInfo}
                                                    list={list}
                                                    item={i}
                                                    searched={searched}
                                                    setSearched={setSearched}
                                                    generateTable={generateTable}
                                                />
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                        itemContent={(index, item) => {
                            if (loader?.length) {
                                return (
                                    <>{item?.id ?
                                        <div className="single-table-row loading-row" style={{border: 'none'}}>
                                            <Skeleton variant="rounded" width={'100%'} height={34}/>
                                        </div>
                                        :
                                        <div className='load-empty-center' style={{left: '-20px'}}>
                                            <TableLoader/>
                                        </div>
                                    }
                                    </>
                                );
                            }

                            if (!loader?.length && (!list?.length || !item?.id)) {
                                return (
                                    <div className='load-empty-center' style={{left: '-120px'}}>
                                        <NotYet
                                            buttonText={emptyState?.emptyBtnText}
                                            EmptySvg={emptyState?.EmptySvg}
                                            clickToAddButton={
                                                emptyState?.clickToEmptyAddButton
                                            }
                                            notTitleText={emptyState?.notTitleText}
                                            notDescText={emptyState?.notDescText}
                                            styles={emptyState?.containerStyles}
                                        />
                                    </div>
                                );
                            }

                            return (
                                <div
                                    key={item?.id}
                                    style={handleClick || onDoubleClick ? {cursor: "pointer", ...getRowForStyle(item)} : getRowForStyle(item)}
                                    className={`single-table-row ${listInfo?.length - 1 === index ? "single-table-row-last" : ""}`}
                                >
                                    {body?.map((cell, ke) => {
                                        if (!cell) return null;
                                        return (
                                            <div
                                                onClick={(e) =>
                                                    handleCellClick(e, cell, item)
                                                }
                                                className="single-table-row-item"
                                                key={ke}
                                                style={{
                                                    width: cell.width || "100%",
                                                    minWidth: cell.minWidth,
                                                    maxWidth: cell?.maxWidth,
                                                    ...getCellForStyle(item),
                                                    ...cell?.styles,
                                                }}
                                            >
                                                {renderItems(item, cell, index) || "---"}
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
